import { Component, EventEmitter } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from '@shared/modal/modal.component';

@Component({
  selector: 'app-input-series-modal',
  templateUrl: './input-series-modal.component.html',
  imports: [ReactiveFormsModule, TranslateModule, ModalComponent],
})
export class InputSeriesModalComponent {

  public finish = new EventEmitter<string | undefined>();

  public seriesControl = new FormControl('', [Validators.required, Validators.pattern(/^\d+$/)]);

  public confirm(): void {
    if (this.seriesControl.invalid) {
      return;
    }
    this.close(this.seriesControl?.value?.trim());
  }

  public cancel(): void {
    this.close();
  }

  private close(result?: string): void {
    this.finish.emit(result);
  }
}

